
import Ugcs from '@/components/Ugcs.vue'
import { UgcVO } from '@/views/biz/ugc/vo/ugc.vo'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {Ugcs}
})
export default class MypageReviews extends Vue{
  @Prop({default: '01'}) tab !: string;
  ugcs: Array<UgcVO> = [] as Array<UgcVO>
}
